<template>
  <div id="app">
    <template v-if="serverType === 'common'">
      <!--页面中间主体部分-->
      <Header
        :merchantData="merchantData"
        :ifOtherHeader="ifOtherHeader"
        :ifShowBack="ifShowBack"
        :ifNotice="ifNotice"
        :qrcodeUrl="qrcodeUrl"
        :privateId="privateId"
        :navData="navData"
      >
        <carmerHeader v-if="privateId && privateId == mid"></carmerHeader>
      </Header>

      <router-view v-if="isRouterAlive"></router-view>
      <div v-if="privateId && privateId == mid">
        <carmerFooter></carmerFooter>
      </div>
      <div v-else>
        <Footer
          :merchantData="merchantData"
          :ifOtherHeader="ifOtherHeader"
          :qrcodeUrl="qrcodeUrl"
          :privateId="privateId"
        ></Footer>
      </div>
      <!-- 20200924 临时弹窗（门票预订  演出预订） -->
      <div class="private-mask" :class="privateMask ? 'newblock' : ''">
        <div class="erweima">
          <div class="erweima-inner">
            <div class="close" @click="changePrivatiMasks(false)">&times;</div>
            <img
              src="https://statics.lotsmall.cn/image/20200924/20200924155240k3s15o.png"
              alt=""
            />
            <div class="tip">请使用微信或支付宝扫码下单</div>
          </div>
        </div>
      </div>
      <!-- 20200924 临时弹窗 （门票预订  演出预订）-->
    </template>
    <template v-else-if="serverType === 'xihu'">
      <XihuLayout v-if="isRouterAlive"></XihuLayout>
    </template>
    <!-- 坝美室外桃园景区 -->
    <template v-else-if="serverType === 'bamei'">
      <!-- <bameiLayout v-if="isRouterAlive"></bameiLayout> -->
      <!-- 改版 -->
      <bameiNewLayout v-if="isRouterAlive"></bameiNewLayout>
    </template>
    <template v-else-if="serverType === 'huangshan'">
      <huangshanLayout v-if="isRouterAlive"></huangshanLayout>
    </template>
    <template v-else-if="serverType === 'keqi'">
      <keqiLayout v-if="isRouterAlive"></keqiLayout>
    </template>
    <template v-else-if="serverType === 'single'">
      <router-view v-if="isRouterAlive"></router-view>
    </template>
    <template v-else-if="serverType === 'shilin'">
      <shilinLayout v-if="isRouterAlive"></shilinLayout>
    </template>
    <!-- 电脑端虚拟票券核销 -->
    <template v-else-if="serverType === 'virtualTicket'">
      <virtualTicketLayout v-if="isRouterAlive"></virtualTicketLayout>
    </template>
    <template v-else-if="serverType === 'shaoxing'">
      <shaoxingLayout v-if="isRouterAlive"></shaoxingLayout>
    </template>
  </div>
</template>

<script>
import "./assets/styles/fonts/iconfont.css";
import { PRIVATE_ID } from "@/common/consts.js";
import api from "@/api/api";
import Header from "@/components/header";
import carmerHeader from "@/components/carmerHeader";
import carmerFooter from "@/components/carmerFooter";
import Footer from "@/components/footer";
import { apiGet } from "@/fetch/api";
import { mapState, mapActions } from "vuex";
import privateServerConfig from "@/common/privateServerConfig";

import XihuLayout from "@/pages/xihu";
import bameiLayout from "@/pages/bamei";
import bameiNewLayout from "@/pages/bameiNew";
import keqiLayout from "@/pages/keqi";
import huangshanLayout from "@/pages/huangshan";
import shilinLayout from "@/pages/shilin";
import virtualTicketLayout from "@/pages/virtualTicket";
import shaoxingLayout from "@/pages/shaoxing";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      navData: {},
      activeDate: 1,
      flag: true,
      isRouterAlive: true,
      ifShowBack: false,
      merchantData: {},
      pageBackFlag: "",
      customList: [],
      ifNotice: false,
      qrcodeUrl: "",
      ifOtherHeader: false,
      privateId: PRIVATE_ID || "",
      serverType: "common"
    };
  },

  computed: {
    ...mapState(["privateMask"]),
    ...mapState("privateConfig", ["mainPageRoute", "mainTitle"]),
    route() {
      return this.$route;
    },
    login() {
      return this.$store.state.login;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    mid() {
      return this.$store.state.m_id;
    },
    spageType() {
      return this.$store.state.pageType;
    }
  },
  watch: {
    route(val) {
      if (this.flag) {
        //保证刷新只有第一次执行
        this.checkLogin();
        this.flag = false;
      }
    },
    mid(val) {
      if (val == "477") {
        this.ifOtherHeader = true;
        this.ifShowBack = true;
      }
    }
  },
  created() {
    let _this = this;
    let m_id = this.$route.query.m_id || localStorage.getItem("m_id");
    if (this.initPrivateServer(m_id)) {
      this.checkLogin();
      return;
    }
    this.$store.dispatch("setMid", m_id);
    this.qrcodeUrl = "http://wap.lotsmall.cn/vue/?m_id=" + m_id;
    let url = api.main.getMerchantInfo;
    let customUrl = api.main.getUsePage;
    console.log(
      "店铺idrrrrrrrrrrrrrr",
      this.$route.query.m_id,
      localStorage.getItem("m_id"),
      m_id,
      this.privateId
    );
    if (Number(m_id) !== Number(this.privateId)) {
      apiGet(url, {}).then(res => {
        this.merchantData = res.data;
      });
      apiGet(customUrl, {
        pageType: "mianPage",
        useRange: "pcWebsite"
      }).then(res => {
        if (
          res.data &&
          res.data.content &&
          JSON.parse(res.data.content).length
        ) {
          console.log('ffffffffffff',JSON.parse(res.data.content))
          this.pageBackFlag = res.data.pageBackFlag;
          this.customList = JSON.parse(res.data.content);
          this.homeTitle = res.data.renovationPageName;
          console.log("this.customList", this.customList);
          this.customBackgroundColor = res.data.renovationPageBack
            ? res.data.renovationPageBack
            : "";
          for (let i = 0; i < this.customList.length; i++) {
            if (this.customList[i].category == "shopinfo") {
              this.shopInfoData = this.customList[i].data;
              this.ifShopInfo = true;
              break;
            }
          }
          this.customList.forEach((item, index) => {
            if (this.customList[index].category == "weather") {
              this.ifWeather = true;
              this.weatherData = this.customList[index].data;
              console.log('gzgzg weather')
              return;
            }
          });
          let noticeDataArr = [];
          this.customList.forEach((item, index) => {
            if (this.customList[index].category == "notice") {
              this.ifNotice = true;
              noticeDataArr.push(this.customList[index].data);
            }
          });
          this.noticeData = noticeDataArr;
          // console.log('noticeData', this.noticeData);
          this.$store.dispatch("pageBackFlag", this.pageBackFlag);
          this.$store.dispatch("customList", this.customList);
          this.$store.dispatch(
            "customBackgroundColor",
            this.customBackgroundColor
          );
        } else {
          this.customList = [];
        }
        this.$store.dispatch("homeTitle", this.homeTitle);
      });
    } else {
      this.homeTitle = "电影小镇";
      this.$store.dispatch("homeTitle", this.homeTitle);
    }
    this.initNav();
  },
  components: {
    Footer,
    Header,
    carmerHeader,
    carmerFooter,
    XihuLayout,
    bameiLayout,
    bameiNewLayout,
    keqiLayout,
    huangshanLayout,
    shilinLayout,
    virtualTicketLayout,
    shaoxingLayout
  },
  methods: {
    ...mapActions(["setMid", "setPrivateMask"]),
    ...mapActions("privateConfig", ["updateServerConfig"]),
    changePrivatiMasks(val) {
      this.setPrivateMask(val);
    },
    initNav() {
      let customUrl = api.main.getUsePage;
      apiGet(customUrl, {
        pageType: "pcPage",
        useRange: "pcWebsite"
      }).then(res => {
        if (res.data && res.data.content) {
          try {
            this.navData = JSON.parse(res.data.content);
            console.log("this.navData", this.navData);
          } catch (error) {
            this.navData = {};
          }
        }
      });
    },
    goOrderList() {
      this.$router.push({ path: "/order/list", query: this.$route.query });
    },
    refresh() {
      this.activeDate++;
    },
    checkLogin() {
      if (localStorage.getItem("xjsc_login_userId_2019_3_8")) {
       
        // isLogin true 不需要登录验证 false 需要登录验证默认值
        apiGet("/leaguer/api/userLeaguer/manage/leaguerInfo", {
          merchantInfoId:
            this.$route.query.m_id || localStorage.getItem("m_id"),
          leaguerId: localStorage.getItem("xjsc_login_userId_2019_3_8"),
          isLogin: this.$route.meta.noCheckLogin
        }).then(res => {
          if (res.status == 200) {
            this.$store.dispatch("updateUserInfo", res.data);
            this.$store.dispatch("updateLoginShow", false);
            this.$store.dispatch("updateLogin", true);
          } else {
            this.$Message.warning(res.message);
          }
        });
      }
    },
    reload() {
      this.isRouterAlive = false;
      //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    initPrivateServer(mId) {
      if (!Object.keys(privateServerConfig).includes(mId)) {
        return false;
      }

      const config = privateServerConfig[mId];
      document.title = config.title;
      this.serverType = config.type;
      this.updateServerConfig({ ...config, id: mId });

      return true;
    }
  },
  watch: {
    $route(val) {
      if (this.serverType !== "common" && val.name === "index") {
        this.$router.push({
          name: this.mainPageRoute
        });
      }
    }
  }
};
</script>

<style lang="scss">
// 20200924 临时
.private-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  display: none;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  &.newblock {
    display: block;
  }
  .erweima {
    position: absolute;
    border: 1px solid #ccc;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translateX(-50%) translateY(-50%);
    display: inline-block;
    width: 400px;
    height: 450px;
    .erweima-inner {
      padding-top: 70px;
      display: block;
      width: 400px;
      height: 450px;
      position: relative;
      .close {
        position: absolute;
        color: #fff;
        text-align: center;
        font-size: 15px;
        top: -15px;
        right: -15px;
        width: 20px;
        height: 20px;
        background: #333;
        line-height: 20px;
        border-radius: 50%;
        border: 1px solid #fff;
      }
      .tip {
        display: inline-block;
        position: absolute;
        bottom: 20px;
        transform: translateX(-50%);
        padding-left: 5px;
        padding-right: 5px;
        width: 100%;
        color: #fff;
        font-size: 16px;
        height: 40px;
        text-align: center;
      }
    }
    img {
      display: block;
      width: 250px;
      height: 250px;
      margin: 10px auto;
    }
  }
}
// 20200924 临时
#app {
  height: 100%;
  overflow: auto;
}
html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
.overflow {
  overflow: hidden;
  height: 100%;
}
// login
.login-wrap {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 999;
}
.login-close {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
/*css reset*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
font,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
caption,
input {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-weight: inherit;
  font-style: inherit;
  font-family: inherit;
  vertical-align: baseline;
}

body {
  font-family: Arial, "Microsoft YaHei";
  font-size: 12px;
  // background:#f6f6f6;
}

ol,
ul {
  list-style: none;
}
table {
  border-collapse: collapse;
}
caption,
th,
td {
  font-weight: normal;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
}
blockquote,
q {
  quotes: "" "";
}
a,
a:hover {
  color: #333;
  text-decoration: none;
}
img {
  border: 0;
  display: block;
}

.cb {
  clear: both;
  height: 0;
  line-height: 0;
  font-size: 0;
}
.color_orange {
  color: #dd5012;
}

/* 边距*/
.m0 {
  margin: 0;
}
.mb10 {
  margin-bottom: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.mb40 {
  margin-bottom: 40px;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}

/* 文字颜色*/
.c3 {
  color: #333;
}
.c6 {
  color: #666;
}
.c9 {
  color: #999;
}
.cf {
  color: #fff;
}

/* 鼠标类型*/
.cp {
  cursor: pointer;
}
.cm {
  cursor: move;
}

/* 背景颜色*/

/* 内容溢出*/
.of {
  overflow: auto;
}
.ofh {
  overflow: hidden;
}
.ofx {
  overflow: auto;
  overflow-x: hidden;
}
.ofy {
  overflow: auto;
  overflow-y: hidden;
}

.tr {
  text-align: right;
}

.fl {
  float: left;
}
.fr {
  float: right;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
  font-size: 0;
  line-height: 0;
}
.clearfix {
  display: inline-block;
}
// *html .clearfix {
//   height: 1%;
// }
.clearfix {
  display: block;
}
// common.css
.block,
.footer-inner {
  width: 1200px;
  margin: 0 auto;
}
.breadcrumb {
  width: 1200px;
  margin: 15px auto 15px;
}

.header,
.footer {
  min-width: 1200px;
  overflow: hidden;
}

.icon-person,
.pagenum a,
.pagenum span,
.pagenum .numtxt,
.pagenum .go-btn,
.breadcrumb a,
.breadcrumb .icon-home,
.numSpinnerBox a,
.list-l .l-tit .icon-arr-r,
.list-l .icon-tit-img {
  display: inline-block;
  *display: inline;
  *zoom: 1;
}

.block,
.footer {
  zoom: 1;
}

.block:after,
.footer:after {
  display: block;
  clear: both;
  visibility: hidden;
  height: 0;
  overflow: hidden;
  content: ".";
}

.wrap {
  min-height: 100%;
  margin-bottom: -55px;
}

.wrap:after {
  display: block;
  content: "";
  height: 55px;
}

.backgw {
  float: left;
  height: 20px;
  line-height: 20px;
  margin-top: 58px;
  font-size: 14px;
  color: #afafaf;
  cursor: pointer;
}

.login-header {
  display: block;
  float: right;
  color: #a98a3c;
  text-align: center;
  margin-top: 44px;
  font-size: 14px;
  img {
    display: inline-block;
  }
}
.username {
  span {
    color: #a98a3c;
  }
}
.login-header a {
  color: #a98a3c;
  margin-top: 5px;
}

.backtop {
  position: absolute;
  width: 155px;
  height: 34px;
  background-color: #c5020f;
  right: 0;
  top: -34px;
  cursor: pointer;
}
.backtop span {
  color: #fff;
  display: block;
  line-height: 34px;
  height: 34px;
  padding-left: 40px;
}
.backtop i.icon_arrtop {
  display: block;
  position: absolute;
  width: 10px;
  height: 5px;
  // background: url(./assets/images/common/common-icon.png) -3px -23px;
  right: 50px;
  top: 15px;
}

.pagenum {
  margin: 15px 0;
  font-size: 0;
  text-align: center;
}
.pagenum.tr {
  text-align: right;
}
.pagenum.tl {
  text-align: left;
}
.pagenum a,
.pagenum span {
  vertical-align: middle;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: #666;
  font-size: 14px;
  margin: 0 6px;
}
.pagenum a {
  padding: 0 15px;
  background-color: #e4eaee;
}
.pagenum a:link,
.pagenum a:visited {
  color: #666;
}
.pagenum a:hover {
  color: #fff;
  background-color: #f70313;
}
.pagenum a.cur {
  color: #fff;
  background-color: #c5020f;
}
.pagenum span {
  padding: 0 10px;
}
.pagenum .numtxt {
  vertical-align: middle;
  margin-right: 10px;
  width: 60px;
  height: 35px;
  border: 1px solid #d1d1d1;
  line-height: 35px;
  font-size: 14px;
  text-align: center;
  color: #666;
}
.pagenum .arr {
  display: block;
  margin-top: 12px;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
}
.pagenum .arr.arr-r {
  border-left: 8px solid #c5020f;
}
.pagenum .arr.arr-l {
  border-right: 8px solid #c5020f;
}
.pagenum .next:hover .arr-r {
  border-left: 8px solid #fff;
}
.pagenum .next.none {
  cursor: default;
}
.pagenum .next.none:hover {
  background-color: #e4eaee;
}
.pagenum .next.none .arr-r {
  border-left: 8px solid #ddd;
}
.pagenum .prev:hover .arr-l {
  border-right: 8px solid #fff;
}
.pagenum .prev.none {
  cursor: default;
}
.pagenum .prev.none:hover {
  background-color: #e4eaee;
}
.pagenum .prev.none .arr-l {
  border-right: 8px solid #ddd;
}
.pagenum .go-btn {
  vertical-align: middle;
  border-width: 0;
  outline: 0;
  width: 37px;
  height: 37px;
  line-height: 37px;
  padding: 0;
  color: #fff;
  background: #c5020f;
  border-radius: 3px;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  -webkit-transition: background-color 0.5s;
  -moz-transition: background-color 0.5s;
  -ms-transition: background-color 0.5s;
  -o-transition: background-color 0.5s;
  transition: background-color 0.5s;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.pagenum .go-btn:hover {
  background-color: #f70313;
}

.icon_star_h {
  vertical-align: middle;
  width: 18px;
  height: 18px;
  background: url("./assets/images/common/icon-sprites.png") -340px 0 no-repeat;
}

.icon_star_g {
  vertical-align: middle;
  width: 18px;
  height: 18px;
  background: url("./assets/images/common/icon-sprites.png") -367px 0 no-repeat;
}

.breadcrumb {
  height: 24px;
  line-height: 24px;
  color: #999;
  font-family: "Adobe 黑体 Std";
  font-size: 12px;
  // margin-bottom: 20px;
}
.breadcrumb a {
  vertical-align: middle;
  font-size: 12px;
  color: #999;
  margin: 0 5px;
}
.breadcrumb a:link,
.breadcrumb a:visited {
  color: #999;
}
.breadcrumb a:hover {
  color: #333;
}
.breadcrumb a.on {
  color: #333;
}
.breadcrumb .icon-home {
  vertical-align: middle;
  background-image: url("./assets/images/common/icon-sprites.png");
  background-position: 0 -49px;
  width: 19px;
  height: 19px;
  // margin-left: 15px;
}

.numSpinnerBox {
  vertical-align: middle;
}
.numSpinnerBox a {
  vertical-align: middle;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
.numSpinnerBox a.add {
  border: 1px solid #b7b7b7;
  border-left: none;
  color: #666;
}
.numSpinnerBox a.add i {
  content: "+";
}
.numSpinnerBox a.add:hover {
  color: #fff;
  background: #c5020f;
}
.numSpinnerBox a.sub {
  border: 1px solid #b7b7b7;
  border-right: none;
  color: #666;
}
.numSpinnerBox a.sub i {
  content: "-";
}
.numSpinnerBox a.sub:hover {
  color: #fff;
  background: #c5020f;
}
.numSpinnerBox a i {
  font-size: 16px;
}
.numSpinnerBox input {
  width: 60px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border: 1px solid #b7b7b7;
  vertical-align: middle;
  color: #333;
}

.base-clr {
  color: #c5020f;
}

.list-l {
  width: 220px;
  float: left;
  margin-left: 8px;
  margin-top: 22px;
}
.list-l .l-tit {
  height: 44px;
  padding-top: 8px;
  background-image: url("./assets/images/detail/left-img.jpg");
}
.list-l .l-tit h3 {
  font-size: 16px;
  color: #666;
  text-align: right;
}
.list-l .l-tit p {
  font-size: 12px;
  line-height: 16px;
  color: #999;
  text-align: right;
}
.list-l .l-tit .icon-arr-r {
  vertical-align: middle;
  width: 14px;
  height: 14px;
  background-image: url("./assets/images/common/icon-sprites.png");
  background-position: -64px -76px;
}
.list-l .icon-tit-img {
  width: 64px;
  height: 52px;
  vertical-align: middle;
  float: left;
  margin-left: 25px;
  margin-right: 5px;
}
.list-l li {
  position: relative;
  display: block;
  height: 57px;
  line-height: 57px;
  margin-bottom: 1px;
  font-size: 14px;
  text-align: center;
  background-color: #ededed;
}
.list-l li.on,
.list-l li:hover {
  background-color: #df0001;
}
.list-l li.on a,
.list-l li:hover a {
  color: #fff;
}
.list-l li.on a:link,
.list-l li.on a:visited,
.list-l li:hover a:link,
.list-l li:hover a:visited {
  color: #fff;
}
.list-l li.on .icon-arr-r,
.list-l li:hover .icon-arr-r {
  background-position: -22px -75px;
}
.list-l li a {
  display: block;
  color: #666;
}
.list-l li a:link,
.list-l li a:visited {
  color: #666;
}
.list-l li .icon-arr-r {
  display: block;
  position: absolute;
  background-position: -41px -75px;
  background-image: url("./assets/images/common/icon-sprites.png");
  right: 10px;
  top: 20px;
  width: 17px;
  height: 17px;
}
// 订单流程
.order-step,
.form-wrap,
.seats-block {
  width: 1200px;
  margin: 0 auto;
}

.order-step li,
.buyer-info li label,
.buyer-info .txt-bd,
.paytype-list label,
.paytype-list input[type="radio"],
.order-btn .pay-btn,
.seat-shop .btn,
.handle a,
.ticket-type-list input[type="checkbox"],
.ticket-type-list .numSpinnerBox,
.type-name,
.select-submit .btn-submit {
  display: inline-block;
  *display: inline;
  *zoom: 1;
}

// .order-step  {
//   width: 1366px;
//   margin: 0 auto 15px;
//   ul{
//     display: block;
//     width: 90%;
//     margin: 0 auto;
//     li{
//       position: relative;
//       z-index: 0;
//       height: 76px;
//       vertical-align: middle;
//       width: 20%;
//       display: inline-block;
//       *display: inline;
//       *zoom: 1;
//     }
//   }
// }
// .order-step li em {
//   color: #999;
//   display: block;
//   height: 18px;
//   line-height: 18px;
//   position: absolute;
//   width: 120px;
//   text-align: center;
//   left: -36px;
//   font-size: 14px;
//   font-style: normal;
// }
// .order-step li span {
//   position: relative;
//   z-index: 2;
//   float: right;
//   display: block;
//   width: 45px;
// }
// .order-step li.done em {
//   color: #c2a980;
// }
// .order-step li.done .icon-circle {
//   font-size: 0;
//   background-position: 0 0;
// }
// .order-step li.done .icon-line {
//   background-color: #c2a980;
// }
// .order-step li.on em {
//   color: #957747;
// }
// .order-step li.on .icon-circle {
//   font-size: 0;
//   background-position: -36px 0;
// }
// .order-step li.on .icon-line {
//   background-color: #957747;
// }
// .order-step .icon-circle {
//   display: block;
//   margin: 4px auto 10px;
//   width: 36px;
//   height: 36px;
//   line-height: 36px;
//   text-align: center;
//   color: #fff;
//   background-image: url("./assets/images/order/order-step.jpg");
//   background-position: -72px 0;
//   font-style: normal;
// }
// .order-step .icon-line {
//   display: block;
//   height: 3px;
//   line-height: 0;
//   font-size: 0;
//   background: #e6e6e6;
//   -webkit-border-radius: 3px;
//   -moz-border-radius: 3px;
//   border-radius: 3px;
//   position: absolute;
//   z-index: 1;
//   top: 21px;
//   width: 175px;
//   right: 44px;
// }
// .order-step .icon-line.last {
//   right: -174px;
// }

// 订单流程
.order-step {
  width: 1200px;
  margin: 0 auto 15px;
  ul {
    display: block;
    width: 90%;
    margin: 0 auto;
    li {
      position: relative;
      z-index: 0;
      height: 76px;
      vertical-align: middle;
      width: 20%;
      display: inline-block;
      *display: inline;
      *zoom: 1;
      em {
        color: #999;
        display: block;
        height: 18px;
        line-height: 18px;
        position: absolute;
        width: 120px;
        text-align: center;
        left: -36px;
        font-size: 14px;
        font-style: normal;
      }
      span {
        position: relative;
        z-index: 2;
        float: right;
        display: block;
        width: 45px;
      }
    }
    li.done {
      em {
        color: #c2a980;
      }
      .icon-circle {
        font-size: 0;
        background-position: 0 0;
      }
      .icon-line {
        background-color: #c2a980;
      }
    }
    li.on {
      em {
        color: #957747;
      }
      .icon-circle {
        font-size: 0;
        background-position: -36px 0;
      }
      .icon-line {
        background-color: #957747;
      }
    }
  }
  .icon-circle {
    display: block;
    margin: 4px auto 10px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    background-image: url("./assets/images/order/order-step.jpg");
    background-position: -72px 0;
    font-style: normal;
  }
  .icon-line {
    display: block;
    height: 3px;
    line-height: 0;
    font-size: 0;
    background: #e6e6e6;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    position: absolute;
    z-index: 1;
    top: 21px;
    width: 175px;
    right: 44px;
  }
  .icon-line.last {
    right: -174px;
  }
}

.empblock,
.line {
  line-height: 0;
  font-size: 0;
}
.empblock {
  height: 10px;
}
// i,em {
//   font-style: normal;
// }

@font-face {
  font-family: "iconfont";
  src: url("./assets/iconfont/iconfont.eot");
  src: url("./assets/iconfont/iconfont.eot?#iefix") format("embedded-opentype"),
    url("./assets/iconfont/iconfont.woff2") format("woff2"),
    url("./assets/iconfont/iconfont.woff") format("woff"),
    url("./assets/iconfont/iconfont.ttf") format("truetype"),
    url("./assets/iconfont/iconfont.svg#iconfont") format("svg");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue